<template>
  <v-menu>
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="#000" icon v-bind="attrs" v-on="on">
        <v-icon>mdi-dots-horizontal</v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-item link v-for="item in items" :key="item.key" @click="$emit(item.key)">
        <v-list-item-title>{{ item.value }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: 'CommonMenu',
  props: {
    items: { type: Array, required: true }
  },
}
</script>

<style lang="less" scoped></style>
